import React, { useState, useEffect } from "react";
import {
  createSubscriptionCheckoutSessionWithTrial,
  signInV2,
  getTriggers,
} from "../../../audiblogsApi";
import queryString from "query-string";
import { observer } from "mobx-react";
import mixpanel from "mixpanel-browser";
import loadingIcon from "../../../Assets/loading.gif";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "../../../firebase";
import userStore from "../../../Stores/User";
import { createStripeSessionAndRedirectToCheckout } from "../../../stripeLogic";

import { loadStripe } from "@stripe/stripe-js";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

const FreeTrialMobile = observer((props) => {
  const { user, idToken } = userStore;
  const articleUrl = queryString.parse(props.location.search).article_url;
  const [isLoading, setIsLoading] = useState(false);
  const [isPremium, setIsPremium] = useState(true);
  const audioElement = new Audio(
    "https://s3.us-east-1.amazonaws.com/audiblogs-conversions-new/5baa81e1-2163-4cae-9a1e-07fbb9b4d9ab.mp3"
  );
  const params = queryString.parse(props.location.search);

  const app = params.app;

  const uiConfig = {
    signInFlow: app === "ios" ? "redirect" : "popup",
    // signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false,
    },
  };

  useEffect(() => {
    mixpanel.track(`Open Trial Page (Onboarding)`);
  }, []);

  useEffect(() => {
    if (isPremium) {
      audioElement.src =
        "https://s3.us-east-1.amazonaws.com/audiblogs-conversions-new/5baa81e1-2163-4cae-9a1e-07fbb9b4d9ab.mp3";
    } else {
      // https://s3.us-east-1.amazonaws.com/audiblogs-conversions-new/b6155c98-5f4f-4042-b8f7-9bc5b2106835.mp3
      audioElement.src =
        "https://s3.us-east-1.amazonaws.com/audiblogs-conversions-new/b6155c98-5f4f-4042-b8f7-9bc5b2106835.mp3";
    }
  }, [isPremium]);

  useEffect(() => {
    // HACK: probably better to fire this in Signin or User.js
    let mixpanel_distinct_id;
    try {
      mixpanel_distinct_id = mixpanel.get_distinct_id();
    } catch (e) {
      console.log(e);
    }

    if (userStore.user && userStore.user.email) {
      signInV2(userStore.idToken, mixpanel_distinct_id).then((res) => {
        console.log(res.data.is_new_user);
        console.log(res.data);
        if (res.data.is_new_user) {
          createStripeSessionAndRedirectToCheckout(userStore.idToken);
        } else {
          getTriggers(idToken).then((res) => {
            // Note: if the user logs in on Trial.js, it gets stuck at "Redirecting..."
            res.data.triggers.forEach((trigger) => {
              if (trigger.name === "has_not_started_trial") {
                createStripeSessionAndRedirectToCheckout(userStore.idToken);
              }
            });
          });
        }
        // console.log("signed in");
      });
    }
  }, [userStore.user]);

  return (
    <>
      {userStore.user ? (
        <div className="center">
          <h1 className="headline">Redirecting...</h1>
          <img src={loadingIcon} style={{height: '50px'}}/>
        </div>
      ) : (
        <div className="center-static">
          <h1 className="headline">
            🎉 Get the {isPremium ? "full" : "Standard"} experience for
            <br></br> <span style={{ color: "rgb(249 77 99)" }}>$0 today</span>
          </h1>
          <h2 className="subheadline">
            {isPremium ? "$4.99/mo" : "$1.99/mo"} after 14 days
            <br></br>
            <span style={{ color: "rgb(255 143 65)", fontWeight: "bold" }}>
              Cancel anytime
            </span>
          </h2>
          {/* <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {" "}
        <button
          className="transparent-button mobile clickable"
          onClick={(e) => {
            audioElement.pause();
            setIsPremium(!isPremium);
          }}
        >
          {isPremium
            ? "Get Standard voice for $1.99/mo"
            : "Get Premium voice for $4.99/mo"}
        </button>
        <button
          className="transparent-button mobile clickable"
          onClick={(e) => {
            e.preventDefault();

            if (!audioElement.paused) {
              audioElement.pause();
              e.target.innerHTML = "Play Sample";
            } else {
              audioElement.play();
              e.target.innerHTML = "Pause Sample";
            }
          }}
        >
          Play Sample
        </button>
      </div> */}

          <div className="features" style={{ margin: "15px 0" }}>
            <div>👏 You'll get 5 hours of credits every month</div>
            <div>👏 Unused credits never expire, even if you cancel</div>
            <div>
              👏 If you run out, you can get additional 5 hours of credits for{" "}
              {isPremium ? "$4.99" : "$1.99"}
            </div>
          </div>

          {/* <div className="cta-div">
        {isLoading ? (
          <img src={loadingIcon}></img>
        ) : (
          <a
            className="cta-button"
            onClick={(e) => {
              mixpanel.track("Click to Stripe Trial Page (Onboarding)");
              createStripeSessionAndRedirectToCheckout();
            }}
          >
            Sounds good
          </a>
        )}
      </div> */}
          <div style={{ marginTop: "50px" }}>
            <StyledFirebaseAuth
              uiConfig={uiConfig}
              firebaseAuth={firebase.auth()}
            />
          </div>
        </div>
      )}
    </>
  );
});

export default FreeTrialMobile;
